// extracted by mini-css-extract-plugin
export default {"title":"F6dbm","titleComment":"_6J5ba","content":"gbuu8","showMoreButton":"Xf3zE","banner":"uGKVk","banner--isHidden":"R2IcT","skeleton-progress":"_3s0Ma"};